// H68 · Fecha por defecto de un movimiento nuevo.
//
// La PWA se queda abierta días: si siempre heredáramos la fecha del último
// movimiento apuntado, un gasto de hoy podría caer sin que se note en otro
// día (o en el mes anterior). Por eso solo se hereda cuando el último se
// apuntó hace muy poco (una ráfaga de tickets del mismo día); si no, hoy.

/** Margen en el que un movimiento nuevo hereda la fecha del anterior. */
export const MARGEN_HEREDAR_FECHA_MS = 10 * 60 * 1000;

type Entrada = {
  /** Fecha (yyyy-MM-dd) del último movimiento apuntado, si lo hay. */
  fechaUltimo: string | null | undefined;
  /** Momento (ms) en que se apuntó ese último movimiento. */
  apuntadoEn: number | null | undefined;
  /** Momento actual (ms). */
  ahora: number;
  /** Hoy, en formato yyyy-MM-dd. */
  hoy: string;
};

export function fechaPorDefectoNuevoMovimiento({
  fechaUltimo,
  apuntadoEn,
  ahora,
  hoy,
}: Entrada): string {
  if (!fechaUltimo || apuntadoEn == null) {
    return hoy;
  }
  const transcurrido = ahora - apuntadoEn;
  if (transcurrido >= 0 && transcurrido < MARGEN_HEREDAR_FECHA_MS) {
    return fechaUltimo;
  }
  return hoy;
}
